var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaltelFixedLineServices(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8959 32.2688L29.0165 35.1483C28.4086 35.7562 27.5448 36.0281 26.489 36.0281C23.0336 36.0281 17.4827 32.9567 12.4116 27.9337L12.3476 27.8697C12.3476 27.8697 12.2997 27.8217 12.2837 27.8057C5.72488 21.183 2.49349 13.7764 5.069 11.2008L7.93246 8.32139C8.7803 7.48955 10.1401 7.48955 10.9719 8.32139L14.1553 11.5048C15.0031 12.3526 15.0031 13.7124 14.1553 14.5442L11.8197 16.8798C10.8279 17.8716 12.6196 21.2309 15.803 24.4143C18.9864 27.5977 22.3457 29.3734 23.3376 28.3976L25.6731 26.062C26.505 25.2142 27.8647 25.2142 28.6965 26.062L31.8959 29.2454C32.7278 30.0773 32.7278 31.437 31.8959 32.2688Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4833 8.5061H28.0583C27.3312 8.5061 26.7417 9.09559 26.7417 9.82277V13.2478C26.7417 13.9749 27.3312 14.5644 28.0583 14.5644H31.4833C32.2105 14.5644 32.8 13.9749 32.8 13.2478V9.82277C32.8 9.09559 32.2105 8.5061 31.4833 8.5061Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2417 8.5061H19.8167C19.0895 8.5061 18.5 9.09559 18.5 9.82277V13.2478C18.5 13.9749 19.0895 14.5644 19.8167 14.5644H23.2417C23.9688 14.5644 24.5583 13.9749 24.5583 13.2478V9.82277C24.5583 9.09559 23.9688 8.5061 23.2417 8.5061Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4833 16.9892H28.0583C27.3312 16.9892 26.7417 17.5787 26.7417 18.3058V21.7308C26.7417 22.458 27.3312 23.0475 28.0583 23.0475H31.4833C32.2105 23.0475 32.8 22.458 32.8 21.7308V18.3058C32.8 17.5787 32.2105 16.9892 31.4833 16.9892Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2417 16.9892H19.8167C19.0895 16.9892 18.5 17.5787 18.5 18.3058V21.7308C18.5 22.458 19.0895 23.0475 19.8167 23.0475H23.2417C23.9688 23.0475 24.5583 22.458 24.5583 21.7308V18.3058C24.5583 17.5787 23.9688 16.9892 23.2417 16.9892Z",
    stroke: "#76BC21",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaltelFixedLineServices);
export default __webpack_public_path__ + "static/media/paltelFixedLineServices.56a1104ba9b32026d58a637c4eea7d86.svg";
export { ForwardRef as ReactComponent };